import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const FAQS = {
  Shipping: [
    ["How long does shipping take?", "Standard delivery arrives in 3-5 business days. Express (1-2 days) is available at checkout. Complimentary shipping on all orders over $150."],
    ["Do you ship internationally?", "We currently ship across the US, Canada, UK, and Australia, with more regions launching soon."],
  ],
  Returns: [
    ["What is your return policy?", "We offer free 30-day returns and exchanges on unworn items with tags attached. Refunds are processed within 5 business days of receipt."],
    ["How do I start a return?", "Visit your account's order history and select 'Return or Exchange', or contact our care team and we'll handle the rest."],
  ],
  Sizing: [
    ["How do your sizes run?", "Our pieces are true to size with a sculpting compression fit. XS (0-2), S (4-6), M (8-10), L (12-14), XL (16-18)."],
    ["What if I'm between sizes?", "For a compressive fit, size down. For a relaxed feel, size up. Every product page includes a detailed size guide."],
  ],
  "Product Care": [
    ["How should I wash my SV pieces?", "Machine wash cold with like colors, tumble dry low. Avoid fabric softener and ironing prints to preserve performance and color."],
    ["Will the fabric pill or fade?", "Our SculptKnit™ and PowerHold™ fabrics are tested for hundreds of wears and washes to resist pilling, fading, and stretching."],
  ],
  Payments: [
    ["What payment methods do you accept?", "We accept all major credit and debit cards through our secure Stripe checkout. Gift cards and discount codes can be applied at checkout."],
    ["Is checkout secure?", "Absolutely. All payments are processed through Stripe with bank-level encryption. We never store your card details."],
  ],
  "Order Tracking & Exchanges": [
    ["How do I track my order?", "Once shipped, you'll receive a tracking link by email. You can also view live order status in your account."],
    ["Can I exchange for a different size?", "Yes — exchanges are free within 30 days. Start one from your order history or reach out to our care team."],
  ],
};

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <div className="container-luxe py-16 text-center">
        <p className="overline text-gold mb-3">Support</p>
        <h1 className="h-display text-5xl sm:text-7xl">Frequently Asked</h1>
      </div>
      <div className="container-luxe pb-24 max-w-3xl">
        {Object.entries(FAQS).map(([section, items]) => (
          <div key={section} className="mb-12">
            <h2 className="overline text-[11px] text-gold mb-4">{section}</h2>
            <Accordion type="single" collapsible className="w-full">
              {items.map(([q, a], i) => (
                <AccordionItem key={i} value={`${section}-${i}`} className="border-hairline">
                  <AccordionTrigger className="font-serif text-xl text-left hover:no-underline" data-testid={`faq-${section}-${i}`}>{q}</AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground font-light leading-relaxed">{a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
}
